import { gql } from '@apollo/client';
import type { Network, NftData } from '@mogul/api-client';

import { nftsApi } from '../../../api';
import assetFields from '../fragments/assetFields';
import listingFields from '../fragments/listingFields';

export const trendingAssetsQuery = gql`
  ${assetFields}
  ${listingFields}
  query Asset($addresses: [String]) {
    assets(
      orderBy: tokenId
      orderDirection: asc
      where: { id_in: $addresses }
    ) {
      ...AssetField
      #activeListings(orderBy: starsPrice, orderDirection: asc) {
      #  ...ListingField
      #}
    }
  }
`;

export async function generateTrendingListQueryTokenAddresses(
  network: Network,
): Promise<{
  addresses: String[];
}> {
  const response = await nftsApi.listMintedNfts(
    {
      trending: true,
      limit: 10,
      network: [network],
    },
    {},
  );
  const assets: NftData[] = response.data.data;
  const trendingNftIds: string[] = [];

  for (const asset of assets) {
    const gqlId = asset.contractAddress + '/' + asset.id;

    trendingNftIds.push(gqlId.toLowerCase());
  }
  return {
    addresses: trendingNftIds,
  };
}
